<style>
    .sidebar {
        font-size: 14px;
        color: #4990E2;
        float: left;
        width: 210px;
        box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.20);
        margin-top: 21px;
    }
    .sidebar ul {
        margin: 0;
    }
    .sidebar ul li {
        height: 20px;
        /* width: 210px; */
        text-align: center;
        padding: 20px 50px 21px;
    }
    .sidebar ul .bg {
        background-position: 0px 0px;
        color: white !important;
    }
    .sidebar ul li div {
        height: 100%;
        text-align: center;
    }
    .sidebar ul li .appointment {
        background-position: 0px -668px;
        padding-left:20px;
    }
    .sidebar ul li .personal {
        background-position: 0px -689px;
        padding-left:20px;

    }
    .sidebar ul li .account {
        background-position: 0px -712px;
        padding-left:20px;

    }
    .sidebar ul li .answer {
        padding-left:20px;

    }
    .sidebar ul li .appointment-bai {
        background-position: 0px -257px;
        
    }
    .sidebar ul li .personal-bai {
        background-position: 0px -278px;
    }
    .sidebar ul li .account-bai {
        background-position: 0px -300px;
    }
    .sidebar ul li .common-bai {

    }
    .invoiceBg{
        padding-left: 20px;
    }
</style>
<template>
    <div class="sidebar">
        <ul>
            <router-link :to="{name:'default_myRegister'}"  v-if="exam_type!=1">
                <li class="AEE-tc" :class="{'bg backJLImg':activeIndex=='1'}">
                    <div class="appointment backJLImg" :class="{'appointment-bai':activeIndex=='1'}">{{domain=='TEM-test'?'考试缴费':$t('sidebar.myApplication')}}</div>
                </li>
            </router-link>
            <router-link :to="{name:'default_myReservation'}"  v-if="exam_type!=2">
                <li class="AEE-tc" :class="{'bg backJLImg':activeIndex=='5'}">
                    <div class="appointment backJLImg" :class="{'appointment-bai':activeIndex=='5'}">{{$t('sidebar.myAppointment')}}</div>
                </li>
            </router-link>
            <router-link :to="{name:'default_myExcuse'}"  v-if="exam_type!=1&&excuseExam==1">
                <li class="AEE-tc" :class="{'bg backJLImg':activeIndex=='6'}">
                    <div class="appointment backJLImg" :class="{'appointment-bai':activeIndex=='6'}">{{$t('sidebar.myExemption')}}</div>
                </li>
            </router-link>
            <router-link :to="{name:'default_myInvoice'}" v-if="exam_type!=1&&invoice_is_open==1">
                <li class="AEE-tc" :class="{'bg backJLImg':activeIndex=='7'}">
                    <div class=" invoiceBg"  :class="{'bg invoiceBgActive':activeIndex=='7'}">{{$t('sidebar.myInvoice')}}</div>
                </li>
            </router-link>
            <router-link :to="{name:'default_userInform'}">
                <li class="AEE-tc" :class="{'bg backJLImg':activeIndex=='2'}">
                    <div class="personal backJLImg" :class="{'personal-bai':activeIndex=='2'}">{{$t('sidebar.personalInformation')}}</div>
                </li>
            </router-link>
            <router-link :to="{name:'default_safeProblem'}" v-if="exam_type!=1">
                <li class="AEE-tc" :class="{'bg backJLImg':activeIndex=='3'}">
                    <div class="account backJLImg" :class="{'account-bai backJLImg':activeIndex=='3'}">{{$t('sidebar.accountSecurity')}}</div>
                </li>
            </router-link>
            <router-link :to="{name:'default_usuQuse'}" v-if="domain!='191026'">
                <li class="AEE-tc" :class="{'bg backJLImg':activeIndex=='4'}">
                    <div class="answer" :class="{'answer-active':activeIndex=='4'}">{{$t('sidebar.helpCenter')}}</div>
                </li>
            </router-link>
        </ul>
    </div>
</template>

<script type="text/ecmascript-6">
    export default {
        data() {
            return {
                exam_type:this.$store.state.examInfo.currentExamInfo.exam_type,
                excuseExam:this.$store.state.examInfo.currentExamInfo.exempt_exam_is_open,
                invoice_is_open:this.$store.state.examInfo.currentExamInfo.invoice_is_open,
                domain: this.$store.state.examInfo.currentExamInfo.domain,
            }
        },
        props: {
            activeIndex: {
                type: String,
                default: '0',
            }
        }
    }
</script>
